import React from "react";

function SvgPowerPoint(props) {
  let blur = "";
  if(props.activeMove){
    blur="40";
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 19.209 18.41"
    >
      <g id="projection-screen" transform="translate(-11.706 -12.925)">
        <path
          id="Path_16433"
          data-name="Path 16433"
          d="M15.5,20.833v1.2a.6.6,0,0,0,1.2,0v-1.2Z"
          transform="translate(5.211 6.499)"
          fill={"#e56353"+blur}
        />
        <g
          id="Group_6603"
          data-name="Group 6603"
          transform="translate(11.706 12.925)"
        >
          <path
            id="Path_16434"
            data-name="Path 16434"
            d="M25.174,12.507H9.567a2.578,2.578,0,0,1-.4-.041v7.845a1.4,1.4,0,0,0,1.4,1.4H24.174a1.4,1.4,0,0,0,1.4-1.4V12.466A2.608,2.608,0,0,1,25.174,12.507Zm-2.983,2.509-3.057,3.716a.8.8,0,0,1-1.054.163l-1.755-1.139-2.6,2.527a.8.8,0,0,1-1.117-1.148l3.057-2.973a.8.8,0,0,1,.994-.1l1.692,1.1L20.954,14a.8.8,0,0,1,1.237,1.017Z"
            transform="translate(-7.766 -8.104)"
            fill={"#e56353"+blur}
          />
          <g id="Group_6602" data-name="Group 6602">
            <path
              id="Path_16435"
              data-name="Path 16435"
              d="M25.408,12.435H9.8a1.8,1.8,0,1,1,0-3.6H25.408a1.8,1.8,0,0,1,0,3.6Z"
              transform="translate(-8 -8.833)"
              fill={"#e56353"+blur}
            />
            <path
              id="Path_16436"
              data-name="Path 16436"
              d="M16.267,24.7a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,16.267,24.7Z"
              transform="translate(-6.663 -6.292)"
              fill={"#e56353"+blur}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgPowerPoint);
